module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v2_common/sheet-d41fe97797c47bd27ed7be56cdda4742.svg";